module.exports = __webpack_public_path__ + "static/ruscitto-truck-2b7c523090bb07072c48ce9c2f61ec31.jpg";